// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"8b4c5f9df66531b189cd","pg-service-gifting-common":"e8273f4470a914ca5937","GiftingTierPick":"fb44f19137b540f4435b","GiftingProductsTray":"35f024aef45991970c04","GiftWrapOverlaySidebar":"904c00e77a774997eb75"}[chunkId] + ".bundle.js";
};